import React from 'react';
import {
  ButtonBase,
  Card,
  ClickAwayListener,
  InputAdornment,
  makeStyles,
  Popper,
  Typography,
} from '@material-ui/core';
import { CloseOutlined, Event } from '@material-ui/icons';
import DynamicIcon from 'components/Common/DynamicIcon';
import { SearchBlock } from 'components/Common/SearchBlock';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  container: {
    '&::-webkit-scrollbar': {
      height: 5,
      width: 5,
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0)',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD1D7',
      borderRadius: 3.5,
    },
    // overflow: 'auto',
    width: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: 7,
    padding: '0px 5px',
  },
  popper: {
    zIndex: theme.zIndex.modal,
  },
  borderedField: {
    background: '#f9f9f9',
    flex: 1,
    border: '1px solid #C4C4C4',
    borderRadius: 4,
    fontSize: '1rem',
    padding: '8px 18px',
    cursor: 'pointer',
    color: '#909090',
    '&:hover': { borderColor: '#000000' },
  },
  borderedFieldMobile: {
    background: '#f9f9f9',
    flex: 1,
    border: '1px solid #C4C4C4',
    borderRadius: 4,
    fontSize: '14px',
    padding: '2px 16px',
    cursor: 'pointer',
    color: '#909090',
    '&:hover': { borderColor: '#000000' },
  },
}));

export const DropdownField = (props) => {
  const { field } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const selectFilter = (key, value) => {
    props.setSelectedFilters({
      ...(props.selectedFilters || {}),
      [key]: value,
    });
  };
  const [selected, setSelected] = React.useState(null);
  const classes = useStyles();
  const open = Boolean(anchorEl);
  const queryFunction = (searchString, searchResults, setList) => {
    if ((searchString || '').length !== 0) {
      let searchRegExp = new RegExp((searchString || '').toLowerCase());
      setList(
        field.items.filter((item) =>
          searchRegExp.test((item.title || '').toLowerCase())
        )
      );
    } else {
      setList(field.items);
    }
  };
  React.useEffect(() => {
    props.localFilters &&
      props.localFilters.hasOwnProperty(field.key) &&
      setSelected(
        field.items.find((item) => item.value === props.localFilters[field.key])
      );
  }, [props.localFilters]);
  return (
    <div style={{ padding: props.isMobile ? '8px 0px' : '10px' }}>
      <div
        style={{ width: props.isMobile ? '40vw' : '14vw', maxWidth: '100%' }}
      >
        <ButtonBase
          style={{ width: '100%', maxWidth: '100%', textAlign: 'left' }}
        >
          <div
            onClick={(event) => setAnchorEl(event.currentTarget)}
            className={
              props.isMobile
                ? classes.borderedFieldMobile
                : classes.borderedField
            }
            style={{
              ...(!!anchorEl ? { borderColor: '#7467F0', borderWidth: 2 } : {}),
              color: !!selected && '#202020',
              maxWidth: '100%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              noWrap
              style={{
                maxWidth: props.isMobile ? '34vw' : '10vw',
                textOverflow: 'ellipsis',
              }}
            >
              {!!selected ? selected.title : field.title || 'Select Filter'}
            </Typography>
            {!!selected ? (
              <CloseOutlined
                style={{ color: '#949494', fontSize: 20 }}
                onClick={(event) => {
                  event.stopPropagation();
                  setAnchorEl(null);
                  setSelected(null);
                  props.handleChange
                    ? props.handleChange(field.key, null)
                    : props.removeFilter(field);
                }}
              />
            ) : (
              <DynamicIcon iconId={933} style={{ height: 20, width: 20 }} />
            )}
          </div>
        </ButtonBase>
      </div>

      <Popper
        label="Select Value"
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        style={{
          width: props.isMobile ? '40vw' : '14vw',
        }}
        className={classes.popper}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <Card elevation={8}>
            <SearchBlock
              onSelect={(selectedItem) => {
                props.handleChange
                  ? props.handleChange(field.key, selectedItem.value)
                  : selectFilter(field.key, selectedItem.value);
                setAnchorEl(null);
                setSelected(selectedItem);
              }}
              selection={(field.items || []).map((item) => item)}
              queryFunction={queryFunction}
            />
          </Card>
        </ClickAwayListener>
      </Popper>
    </div>
  );
};

export const DateField = (props) => {
  const { field } = props;
  const [selected, setSelected] = React.useState(null);
  React.useEffect(() => {
    props.localFilters &&
      props.localFilters.hasOwnProperty(field.key) &&
      setSelected(moment.unix(props.localFilters[field.key]));
  }, [props.localFilters]);
  return (
    <div style={{ width: '14vw', padding: 10 }}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        {
          <DatePicker
            size="small"
            label={field.title || 'Select Date'}
            format={field.format || 'DD/MM/YYYY'}
            views={
              field.format &&
              field.format !== 'DD/MM/YYYY' && [
                ...(field.format.includes('Y') ? ['year'] : []),
                ...(field.format.includes('M') ? ['month'] : []),
              ]
            }
            inputVariant="outlined"
            value={selected}
            maxDate={field.disableFuture && new Date()}
            InputLabelProps={{
              shrink: selected && true,
            }}
            InputProps={{
              style: {
                background: '#f9f9f9',
              },
              endAdornment: (
                <InputAdornment position="end">
                  <Event style={{ color: '#949494' }} />
                  {selected && (
                    <CloseOutlinedIcon
                      cursor={'pointer'}
                      onClick={(event) => {
                        event.stopPropagation();
                        props.removeFilter(field);
                        setSelected(null);
                      }}
                      style={{ marginLeft: 5, color: '#949494' }}
                    />
                  )}
                </InputAdornment>
              ),
            }}
            onChange={(value) => {
              value &&
                props.setSelectedFilters(() => ({
                  ...(props.selectedFilters || {}),
                  [field.key]: value.unix(),
                }));
              value && setSelected(value);
            }}
            fullWidth={true}
            cancelLabel={
              <Typography style={{ fontWeight: 'bold' }}>CANCEL</Typography>
            }
            okLabel={<Typography style={{ fontWeight: 'bold' }}>OK</Typography>}
          />
        }
      </MuiPickersUtilsProvider>
    </div>
  );
};
